/*
 *  presentationModelFactory
 *
 *  Builds Models that distinguish between presentation and data.
 *  DataList - is a Collection of DataItem
 *  DataItem - wraps each field in a list to incorporate two values:
 *  	dataMdl (the original data)
 *  	presMdl (anything that isn't data and also should not be returned to backend)
 */

app.factory('presentationModelFactory', presentationModelFactory);

presentationModelFactory.$inject = ['$http', '$q'];

function presentationModelFactory($http, $q) {
  /*
	 * DataList
	 */

  // Constructor (only works as a helper to set __proto__ of the new array afterwards)
  // see here:
  // http://perfectionkills.com/how-ecmascript-5-still-does-not-allow-to-subclass-an-array/#andrea_giammarchi_solution
  function DataList() {}

  DataList.prototype = new Array();

  function makeDataList(data) {
    var arr = new DataList(),
      newdata = [];

    // Go through array and turn every item into a DataItem
    _.each(data, function(item) {
      newdata.push(makeDataItem(item));
    });

    arr.push.apply(arr, newdata);

    return arr;
  }

  /*
	 * DataItem
	 */
  function getPlainData(data) {
    return _.map(data, function(item) {
      return item.dataMdl;
    });
  }

  /*
	 * DataItem
	 */

  function DataItem(data) {
    var that = this;
    this.dataMdl = data;
    this.presMdl = {};
    this.presMdl.getDataItem = function() {
      return that;
    };
  }

  function makeDataItem(data) {
    return new DataItem(data);
  }

  return {
    makeDataList: makeDataList,
    makeDataItem: makeDataItem,
    getPlainData: getPlainData
  };
}

export default presentationModelFactory;
